import type { UnsplitFigures, VatRateFigures, VatRatePercent } from '../types/dealerFundStatementPeriod.types';
import type { StatementLine } from './statementBlocks';

export type RateCell =
    | { kind: 'none' }
    | { kind: 'rate'; percent: VatRatePercent }
    | { kind: 'rates'; count: number }
    | { kind: 'unsplit' };

export type LineSubRow =
    | { kind: 'rate'; figures: VatRateFigures }
    | { kind: 'unsplit'; postings: number; gross: string };

const hasUnsplit = (unsplit: UnsplitFigures): boolean => unsplit.postings > 0;

export const hasRecordedFigures = (line: StatementLine): boolean => line.vatRates.length > 0;

export const lineRateCell = (line: StatementLine): RateCell => {
    const unsplit = hasUnsplit(line.unsplit);
    if (!hasRecordedFigures(line)) return unsplit ? { kind: 'unsplit' } : { kind: 'none' };
    if (line.vatRates.length === 1 && !unsplit) return { kind: 'rate', percent: line.vatRates[0].vatRatePercent };
    return { kind: 'rates', count: line.vatRates.length };
};

export const lineSubRows = (line: StatementLine): LineSubRow[] => {
    if (lineRateCell(line).kind !== 'rates') return [];
    const rates: LineSubRow[] = line.vatRates.map((figures) => ({ kind: 'rate', figures }));
    return hasUnsplit(line.unsplit)
        ? [...rates, { kind: 'unsplit', postings: line.unsplit.postings, gross: line.unsplit.gross }]
        : rates;
};
